import { WithLoading, dialogFunction } from 'common/components';

import {
  IXOneFooter,
  IXOneGrid,
  IXOneHeader,
  IXOneMessage,
  IXOneTotalFee,
  RIVIRBillingReview,
  useIXOneColumns,
} from '../ixone-credit-card';

import { ContentConfirmRequest } from '../ixone-section/IXOneCapture';

import { useMutateMakeProductActive, useValidateActiveProduct } from './hooks';
import { useCheckPaymentTerm } from '../cod-payment/hooks';

import { useDispatchReloadPage } from 'hooks/useReloadPage';
import { productFullViewKeys, useVisibleModal } from 'hooks';
import { COD_PAYMENT_TYPE_VIEW, CODChargeValidating } from '../cod-payment';
import { keys } from 'pages/company-profile/components/tabs/billing/queries';

export const ActiveProductCharge = ({
  productIds,
  onCancel,
  isFullView,
  children,
}) => {
  const { isLoading, passedProducts } = useValidateActiveProduct({
    productIds,
  });

  const [
    visibleReviewBilling,
    { onModal: onModalReviewBilling, offModal: offModalReviewBilling },
  ] = useVisibleModal();

  const { isCODTerm, isInvoicedTerm } = useCheckPaymentTerm();

  const { columns } = useIXOneColumns({ isActiveProduct: true });

  const refetchProductGrid = useDispatchReloadPage();

  const activeProductChargeMutation = useMutateMakeProductActive({
    meta: {
      invalidates: isFullView
        ? [
            productFullViewKeys.itemData(passedProducts?.[0]?.productId),
            keys.allMemberBillingStatement(),
          ]
        : [keys.allMemberBillingStatement()],
    },
  });

  const totalFee = passedProducts.reduce((accumulator, product) => {
    return accumulator + product.fee;
  }, 0);

  const confirmRequest = async () => {
    const params = {
      productIds: passedProducts.map((product) => product.productId),
    };

    await activeProductChargeMutation.mutateAsync(params, {
      onSuccess: () => {
        onCancel();
        refetchProductGrid();
      },
    });
  };

  const handleMakeProductActive = () => {
    dialogFunction({
      type: 'warn',
      content: <ContentConfirmRequest onClick={onModalReviewBilling} />,
      okText: 'Agree',
      onOk: confirmRequest,
    });
  };

  return (
    <CODChargeValidating
      fee={totalFee}
      typeView={COD_PAYMENT_TYPE_VIEW.activeProduct}
      confirmRequest={confirmRequest}
      chargeItems={passedProducts}
    >
      {({ handleCODCharge }) => {
        return (
          <WithLoading loading={isLoading}>
            <IXOneHeader style={{ minHeight: 110 }} />
            <IXOneMessage />
            <IXOneGrid
              columns={columns}
              productList={passedProducts}
              style={{ height: 200 }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-end',
                  marginTop: 4,
                }}
              >
                {children}
                <IXOneTotalFee fee={totalFee} />
              </div>
            </IXOneGrid>
            <div style={{ paddingTop: 6 }}>
              <IXOneFooter
                onSave={() => {
                  if (isCODTerm) {
                    handleCODCharge();
                  } else if (isInvoicedTerm) {
                    confirmRequest();
                  } else {
                    handleMakeProductActive();
                  }
                }}
                loading={activeProductChargeMutation.isLoading}
                disabled={!passedProducts?.length}
                onCancel={onCancel}
              />
            </div>

            {visibleReviewBilling && (
              <RIVIRBillingReview
                visible={visibleReviewBilling}
                onCancel={offModalReviewBilling}
              />
            )}
          </WithLoading>
        );
      }}
    </CODChargeValidating>
  );
};
